/* eslint-disable jira/filename-case */
export const UPFLOW_MODAL_STORE_NAME = 'upflow-modal-store';
